import type { IconProps } from '../types/IconProps.ts';
export const Bitcoin: IconProps = {
    name: 'Bitcoin',
    children: [
        `<path d="m10.11 2.79-2.2 17.86M7.85 4.5l5.46.67a3.5 3.5 0 1 1-.85 6.95L7 11.45M7.07 11.46l5.46.67a3.5 3.5 0 0 1-.86 6.94l-5.45-.67M14.09 3.23l-.25 1.99M11.9 21.1l.25-1.98" />`,
    ]
};